define('common/models/date_model',['require','exports','module','backbone','lib/util'],function (require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
    util = require('lib/util');

  module.exports = Backbone.Model.extend({
    defaults: {
      from: '',
      to: '',
    },
    initialize: function (options) {
      if (options && options.from && options.to) return;
      var today = new Date(),
        firstDate = new Date();
      firstDate.setDate(today.getDate() - 29);
      this.set({
        to: util.formatDate(today),
        from: util.formatDate(firstDate),
      });
    },
    getFirstDate: function () {
      return new Date(this.get('from'));
    },
    _isValidFormat: function (date) {
      var ymd = date.split('/'),
        year = ymd[0],
        month = +ymd[1],
        day = +ymd[2];
      return (
        !isNaN(+year) &&
        year.length === 4 &&
        !isNaN(month) &&
        month > 0 &&
        month <= 12 &&
        !isNaN(day) &&
        day >= 1 &&
        day <= 31
      );
    },
    validate: function (attrs) {
      var errors = [];

      if (!(attrs.from && this._isValidFormat(attrs.from))) {
        errors.push({
          selector: 'js-from-date',
          errorKey: 'errorText',
        });
      }
      if (!(attrs.to && this._isValidFormat(attrs.to))) {
        errors.push({
          selector: 'js-to-date',
          errorKey: 'errorText',
        });
      }
      if (attrs.from && attrs.to && attrs.from > attrs.to) {
        errors.push({
          selector: 'js-to-date',
          errorKey: 'badRange',
        });
      }

      if (errors.length) return errors;
    },
  });
});

